import { createTailwindMerge } from "./create-tailwind-merge";
import { getDefaultConfig } from "./default-config";

export const twMerge = createTailwindMerge(getDefaultConfig);
